// @ts-strict-ignore
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { ResumeDatabaseBanner } from 'components/Banners/ResumeDatabaseBanner';
import { SalarySurveyBanner } from 'components/Banners/SalarySurveyBanner';
import { Box } from 'components/Box';
import { bannerIsDismissed as gradFairsBannerisDismissed } from 'components/GradFairs/GradFairsBanner';
import GradFairsBannerTop from 'components/GradFairs/GradFairsBannerTop';
import { ClientOnly } from 'containers/ClientOnly';
import { State as MainState } from 'store/main';
import { setAdTypeOnPageLoad } from 'store/main/ducks/layout';
import { promoteResumeDatabase } from 'utils/resumeDatabase';
import { promoteSalarySurvey } from 'utils/salarySurvey';

export function BannerAds() {
  const { currentUser, adTypeOnPageLoad, hideSalarySurveyAd } = useSelector(
    (state: MainState) => ({
      adTypeOnPageLoad: state.layout.adTypeOnPageLoad,
      hideSalarySurveyAd: state.layout.hideSalarySurveyAd,
      currentUser: state.currentUser,
    })
  );
  const dispatch = useDispatch();
  const history = useHistory();

  const hasSalarySurveyBanner =
    !history.location.pathname.includes('/survey') &&
    !hideSalarySurveyAd &&
    promoteSalarySurvey({
      // @ts-expect-error fix me
      currentUser,
      allowDismissal: true,
    });

  useEffect(() => {
    if (
      currentUser.isLoaded &&
      adTypeOnPageLoad !== 'SALARY_SURVEY' &&
      hasSalarySurveyBanner
    ) {
      dispatch(setAdTypeOnPageLoad('SALARY_SURVEY'));
    }
  }, [currentUser.isLoaded, dispatch, adTypeOnPageLoad, hasSalarySurveyBanner]);

  const hasResumeDatabaseBanner =
    !hasSalarySurveyBanner &&
    adTypeOnPageLoad !== 'SALARY_SURVEY' &&
    promoteResumeDatabase({
      // @ts-expect-error fix me
      currentUser,
      allowLoggedOut: true,
    });

  useEffect(() => {
    if (
      currentUser.isLoaded &&
      adTypeOnPageLoad !== 'RESUME_DB' &&
      hasResumeDatabaseBanner
    ) {
      dispatch(setAdTypeOnPageLoad('RESUME_DB'));
    }
  }, [
    currentUser.isLoaded,
    adTypeOnPageLoad,
    hasResumeDatabaseBanner,
    dispatch,
  ]);

  const hasGradFairsBanner =
    !hasSalarySurveyBanner &&
    !['RESUME_DB', 'SALARY_SURVEY'].includes(adTypeOnPageLoad) &&
    !hasResumeDatabaseBanner &&
    !gradFairsBannerisDismissed() &&
    currentUser.isLoaded &&
    CURRENT_LOCALE === 'en';

  return (
    <Box
      data-qa-id="ads-container"
      mt={[60, null, null, 0]}
      mb={[-60, null, null, 0]}
    >
      <ClientOnly>
        {hasGradFairsBanner && <GradFairsBannerTop />}
        {hasResumeDatabaseBanner && (
          // @ts-expect-error fix me
          <ResumeDatabaseBanner currentUser={currentUser} />
        )}
        {hasSalarySurveyBanner && <SalarySurveyBanner />}
      </ClientOnly>
    </Box>
  );
}
